import { name as appName, version as appVersion } from '../../package.json';
import { inTemporaryStore, inPersistentStore } from '../utils/storage.util';
import { keycloak } from '../auth';

const axios = require('axios');

function rejectErrorHandler(error) {
  return Promise.reject(error);
}

// Interceptios register
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response != null &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      return setTimeout(
        () => (window.location = keycloak.createLoginUrl()),
        800
      );
    }
    return rejectErrorHandler(error);
  }
);

axios.interceptors.request.use(
  async (config) => {
    const token = inTemporaryStore.getItem('token');

    if (token) {
      if (config.headers['content-type']) {
        config.headers = {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Credentials': true,
          'content-type': config.headers['content-type'],
        };
      } else {
        config.headers = {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Credentials': true,
        };
      }
      return config;
    }
  },
  (error) => {
    rejectErrorHandler(error);
  }
);

export const getEnv = async (property) => {
  let data = {};
  const cacheKey = `env.json of ${appName} at ${appVersion}`;
  if (inPersistentStore.hasItem(cacheKey)) {
    data = inPersistentStore.getItem(cacheKey);
  } else {
    const resp = await axios.get('/env.json');
    data = resp.data;
    inPersistentStore.setItem(cacheKey, data);
  }
  return data?.[property];
};

export default axios;
